
import { ChangeDetectorRef, Component, HostListener, Injector, ViewChild, ViewEncapsulation } from '@angular/core';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { environment } from '../../../../environments/environment';
import { DetailedMeddraViewComponent } from '../../../shared/component/detailed-view/detailed-meddra-view/detailed-meddra-view.component';
import { TreeViewComponent } from '../../../shared/component/tree-view/tree-view.component';
import { AuthService } from '../../../shared/service/auth-service/auth-service.service';
import { Art57Section } from '../../../shared/ui/Art57Section/Art57Section';
import { MeddraTerm } from '../../../shared/ui/Data/MeddraData/MeddraTerm';
import { BaseNode } from '../../../shared/ui/Node/BaseNode';
import { HierarchyMode, MeddraNode } from '../../../shared/ui/Node/MeddraNode/MeddraNode';
import { MeddraService } from '../../../shared/service/meddra-service/meddra.service';
import { FieldDefinition } from '../message/fieldDefinition';
import { HLTListView } from '../../../shared/ui/Data/MeddraData/HLTListView';
import { PTListView } from '../../../shared/ui/Data/MeddraData/PTListView';
import { LLTListView } from '../../../shared/ui/Data/MeddraData/LLTListVIew';
import { HLGTListView } from '../../../shared/ui/Data/MeddraData/HLGTListView';
import { SOCListView } from '../../../shared/ui/Data/MeddraData/SOCListView';
import { TreeNodeMeddraLevel } from '../../../shared/ui/Node/MeddraNode/ListEntity/TreeNodeMeddraLevel';
import { DummyNode } from '../../../shared/ui/Node/DummyNode';
import { SectionService } from '../../../shared/service/section-service/section-service';
import { Art57NodeUtils } from '../../../shared/ui/Node/Art57Node/Art57NodeUtils';
import { TreeNodeMeddraLevelItem } from '../../../shared/ui/Node/MeddraNode/ListEntity/TreeNodeMeddraLevelItem';
import { MINIMUM_TREE_WITDH } from '../../../shared/ui/Constants';
import { ErrorControlUtil } from '../../../shared/ui/ErrorControlUtil';
import { FormlyFormBuilder } from '@ngx-formly/core';
import { FieldsErrorsControl } from '../../../shared/ui/FieldErrorsControl';
import { QueryNode } from '../../../shared/ui/Node/QueryNode';
import { QueryConditionsNode } from '../../../shared/ui/Node/QueryConditionsNode';
import { MeddraQueryNode } from '../../../shared/ui/Node/MeddraNode/MeddraQueryNode';
import { EntityEnum } from '../../../shared/ui/Node/EntityEnum';
import { QueryFieldsNode } from '../../../shared/ui/Node/QueryFieldsNode';
import { MeddraQueryResultNode } from '../../../shared/ui/Node/MeddraNode/MeddraQueryResultNode';

@Component({
  selector: 'app-meddra',
  templateUrl: './meddra.component.html',
  styleUrl: './meddra.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class MeddraComponent {

  @ViewChild('tree_view_component') tree_view_component!: TreeViewComponent;
  @ViewChild('detail_meddra_view_component') detail_view_component!: DetailedMeddraViewComponent;
  nodes: BaseNode[] = [];
  selectedNode!: MeddraNode;

  constructor(
    public injector: Injector,
    public authService: AuthService,
    public meddraService: MeddraService,
    public sectionService: SectionService,
    private formlyBuilder: FormlyFormBuilder,
    private cdr: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    public art57Sections: Art57Section) {
  }

  //Initialize 
  ngOnInit() {
    this.initializeSection();
    this.sectionService.changeMeddraSelectedNode$.subscribe({ next: node => this.onSelectedNodeChange(node) })
  }

  onResetApplication() {
    this.injector.get(Art57Section).resetApplication().then(applicationReseted => {
      if (applicationReseted) {
        this.initializeSection();
      }
    });

  }


  onResetSection() {
    this.injector.get(Art57Section).resetSection(this.injector.get(Art57Section).meddra).then(sectionReseted => {
      if (sectionReseted) {
        this.initializeSection();
      }
    });
  }

  leftColumnWidth: number = this.injector.get(Art57Section).tree_width;
  rightColumnWidth: number = window.innerWidth - this.leftColumnWidth;

  onResize(clientX: number): void {
    const container = document.querySelector('#main-container') as HTMLElement;

    if (container) {
      const containerRect = container.getBoundingClientRect();
      this.injector.get(Art57Section).tree_width = clientX - containerRect.left;
      const minWidth = MINIMUM_TREE_WITDH;
      const maxWidth = containerRect.width - 100;

      this.leftColumnWidth = Math.max(minWidth, Math.min(this.injector.get(Art57Section).tree_width, maxWidth));
    }
  }

  isResizing: boolean = false;
  onResizing(isResizing: boolean) {
    this.isResizing = isResizing;
  }



  //Selection node event
  onNodeSelect(event: any) {

    this.injector.get(MeddraService).loading.next(false);

    if (event.node instanceof TreeNodeMeddraLevelItem
      && event.node.children!.length == 1
      && event.node.children[0] instanceof DummyNode) {
      event.node.children = [];
      event.node.createChildren();
    } else if (event.node.data instanceof MeddraTerm
      && event.node.children!.length == 1
      && event.node.children[0] instanceof DummyNode) {

      event.node.children = [];

      switch (event.node.entityName) {
        case EntityEnum.hlgt:

          if (event.node.hierarchyMode == HierarchyMode.DESCENDING) {
            //Retrieve "High Level Terms for this HLGT term"
            this.injector.get(MeddraService).getAll(event.node, EntityEnum.hlt, `hlgt_code:eq:${event.node.data.model.code}`).subscribe(
              {
                next: (data: any) => {
                  let node = new MeddraNode(this.injector, new HLTListView(data.result), `High Level Terms (${data.result.length})`, 'hlt', null, event.node, HierarchyMode.DESCENDING);
                  data.result.forEach((i: any) => node.children!.push(new MeddraNode(this.injector, new MeddraTerm(new FieldDefinition(this.injector).hltFields, i), i.name, EntityEnum.hlt, this.injector.get(Art57Section).meddra.hltTermsTreeNode, event.node, HierarchyMode.DESCENDING)));
                  event.node.children!.push(node);
                }
              });
          } else {
            //Retrieve "High Level Terms for this HLGT term"
            this.injector.get(MeddraService).getAll(event.node, EntityEnum.soc, `hlgt_code:eq:${event.node.data.model.code}`).subscribe(
              {
                next: (data: any) => {
                  let node = new MeddraNode(this.injector, new SOCListView(data.result), `System Organ Class (${data.result.length})`, 'soc', null, event.node, HierarchyMode.ASCENDING);
                  data.result.forEach((i: any) => node.children!.push(new MeddraNode(this.injector, new MeddraTerm(new FieldDefinition(this.injector).socFields, i), i.name, EntityEnum.soc, this.injector.get(Art57Section).meddra.socTermsTreeNode, event.node, HierarchyMode.ASCENDING)));
                  event.node.children!.push(node);
                }
              });
          }
          break;

        case EntityEnum.hlt:
          if (event.node.hierarchyMode == HierarchyMode.DESCENDING) {
            //Retrieve "Preferred Terms for this HLT term"
            this.injector.get(MeddraService).getAll(event.node, EntityEnum.pt, `hlt_code:eq:${event.node.data.model.code}`).subscribe(
              {
                next: (data: any) => {
                  let node = new MeddraNode(this.injector, new PTListView(data.result), `Preferred Terms (${data.result.length})`, 'pt', null, event.node, HierarchyMode.DESCENDING);
                  data.result.forEach((i: any) => node.children!.push(new MeddraNode(this.injector, new MeddraTerm(new FieldDefinition(this.injector).ptFields, i), i.name, EntityEnum.pt, this.injector.get(Art57Section).meddra.ptTermsTreeNode, event.node, HierarchyMode.DESCENDING)));
                  event.node.children!.push(node);
                }
              });
          } else {
            this.injector.get(MeddraService).getAll(event.node, EntityEnum.hlgt, `hlt_code:eq:${event.node.data.model.code}`).subscribe(
              {
                next: (data: any) => {
                  let node = new MeddraNode(this.injector, new HLGTListView(data.result), `High Level Group Terms (${data.result.length})`, 'hlgt', null, event.node, HierarchyMode.ASCENDING);
                  data.result.forEach((i: any) => node.children!.push(new MeddraNode(this.injector, new MeddraTerm(new FieldDefinition(this.injector).hlgtFields, i), i.name, EntityEnum.hlgt, this.injector.get(Art57Section).meddra.hlgtTermsTreeNode, event.node, HierarchyMode.ASCENDING)));
                  event.node.children!.push(node);
                }
              });
          }
          break;

        case EntityEnum.pt:
          if (event.node.hierarchyMode == HierarchyMode.DESCENDING) {
            //Retrieve "Low Level Terms for this PT term"
            this.injector.get(MeddraService).getAll(event.node, EntityEnum.llt, `pt_code:eq:${event.node.data.model.code}`).subscribe(
              {
                next: (data: any) => {
                  let node = new MeddraNode(this.injector, new LLTListView(data.result), `Low Level Terms (${data.result.length})`, 'llt', null, event.node, HierarchyMode.DESCENDING);
                  data.result.forEach((i: any) => node.children!.push(new MeddraNode(this.injector, new MeddraTerm(new FieldDefinition(this.injector).lltFields, i), i.name, EntityEnum.llt, this.injector.get(Art57Section).meddra.lltTermsTreeNode, event.node, HierarchyMode.DESCENDING)));
                  event.node.children!.push(node);
                }
              });
            break;
          } else {
            //Retrieve "High Level Terms for this PT term"
            this.injector.get(MeddraService).getAll(event.node, EntityEnum.hlt, `pt_code:eq:${event.node.data.model.code}`).subscribe(
              {
                next: (data: any) => {
                  let node = new MeddraNode(this.injector, new HLTListView(data.result), `High Level Terms (${data.result.length})`, EntityEnum.hlt, null, event.node, HierarchyMode.ASCENDING);
                  data.result.forEach((i: any) => node.children!.push(new MeddraNode(this.injector, new MeddraTerm(new FieldDefinition(this.injector).hltFields, i), i.name, EntityEnum.hlt, this.injector.get(Art57Section).meddra.hltTermsTreeNode, event.node, HierarchyMode.ASCENDING)));
                  event.node.children!.push(node);
                }
              });
            break;
          }

        case EntityEnum.soc:

          if (event.node.hierarchyMode == HierarchyMode.DESCENDING) {
            //Retrieve "High Level Terms for this HLGT term"
            this.injector.get(MeddraService).getAll(event.node, EntityEnum.hlgt, `soc_code:eq:${event.node.data.model.code}`).subscribe(
              {
                next: (data: any) => {
                  let node = new MeddraNode(this.injector, new HLGTListView(data.result), `High Level Group Terms (${data.result.length})`, EntityEnum.hlgt, null, event.node, HierarchyMode.DESCENDING);
                  data.result.forEach((i: any) => node.children!.push(new MeddraNode(this.injector, new MeddraTerm(new FieldDefinition(this.injector).hlgtFields, i), i.name, EntityEnum.hlgt, this.injector.get(Art57Section).meddra.hlgtTermsTreeNode, event.node, HierarchyMode.DESCENDING)));
                  event.node.children!.push(node);
                }
              });
          }
          break;
      }
    }
    this.selectedNode = event.node;
    if (this.selectedNode) {
      this.art57Sections.meddra.selectedNode = this.selectedNode;
      this.expandParentNodes(this.selectedNode);
    }
  }

  //Model changed
  onModelChange(model: any) {
    if (this.selectedNode) {
      if (this.selectedNode instanceof MeddraNode) {
        this.selectedNode.refreshLabel();
      }
    }
  }

  initializeSection() {
    //Create TreeView template
    this.nodes = this.art57Sections.meddra.treeView;
    this.onNodeSelect({ node: this.art57Sections.meddra.selectedNode });
  }

  onSelectedNodeChange(selectedNode: BaseNode) {
    this.onNodeSelect({ node: selectedNode });
    this.expandParentNodes(selectedNode);
  }

  expandParentNodes(node: TreeNode) {
    node.expanded = true;
    if (node.parent) {
      this.expandParentNodes(node.parent);
    }
  }


  setTreeViewScroll(key: string) {
    if (key != '') {
      const treeView = this.tree_view_component;
      if (treeView) {
        treeView.setScrollAtSelectedElement(key);
      }
    }
  }

  onRemoveNode(nodeToRemove: any) {
    if (nodeToRemove && nodeToRemove.parent) {
      let parentNode: BaseNode = nodeToRemove.parent;
      let labelTemplate = parentNode.labelTemplate;
      this.confirmationService.confirm({

        header: 'Remove',
        message: `Are you sure you want to remove the results from the list?`,
        icon: 'pi pi-question-circle',
        acceptLabel: 'OK',
        rejectLabel: 'Cancel',
        accept: () => {

          //Remove from treeview
          parentNode!.children!.splice(parentNode!.children!.indexOf(nodeToRemove), 1);

          //Remove from list
          parentNode.data.model.splice(parentNode.data.model.indexOf(nodeToRemove.data.model), 1);

          this.onSelectedNodeChange(parentNode);

          this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Item has been removed', life: environment.successElapsedTime });
        },
        reject: () => {
          // do nothing
        }
      });
    }
  }

  onRunQuery(selectedNode: QueryNode) {
    if (!this.existsErrors(selectedNode)) {
      const queryNode: any = Art57NodeUtils.findFirstCurrentOrParentNodeOfType(selectedNode, QueryNode);
      queryNode.executeQuery(selectedNode);
    }
  }


  onRemoveSelectedNodes(nodeList: any) {
    this.confirmationService.confirm({
      header: 'Remove',
      message: 'Are you sure you want to remove all selected Items?',
      icon: 'pi pi-question-circle',
      acceptLabel: 'OK',
      rejectLabel: 'Cancel',
      accept: () => {
        let showSuccesMessage = false;
        if ((nodeList.children.filter((element: any) => element.checked)).length > 0) {
          nodeList.children = nodeList.children.filter((element: any) => !element.checked)
          showSuccesMessage = true;
        }
        if (showSuccesMessage) {
          this.selectedNode?.refreshLabel();
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Items have been removed', life: environment.successElapsedTime });
        } else {
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'Items already not selected', life: environment.successElapsedTime });
        }
      },
      reject: () => {
        // do nothing
      },
    });
  }

  onButtonAction(buttonAction: any) {
    switch (buttonAction.action) {
      case 'resetApplication':
        this.onResetApplication();
        break;
      case 'resetSection':
        this.onResetSection();
        break;
      case 'remove':
        this.onRemoveNode(buttonAction.param);
        break;
      case 'removeAll':
        this.onRemoveSelectedNodes(buttonAction.param);
        break;
      case 'runQuery':
        this.onRunQuery(buttonAction.param);
        break;
      case 'setVersion':
        this.meddraService.setVersion(buttonAction.param);
        this.art57Sections.meddra.cleanSection();
        this.initializeSection();
        break;
      case 'exportToExcel':
        this.exportToExcel(buttonAction.param);
        break;
      case 'runToExcel':
        this.runToExcel(buttonAction.param);
        break;
      case 'nextPage':
        this.onNextPage(buttonAction.param);
        break;
      case 'topPage':
        this.onTopPage(buttonAction.param);
        break;
      case 'previousPage':
        this.onPreviousPage(buttonAction.param);
        break;
      case 'loadMeddraNode':
        this.onLoadMeddraNode(buttonAction.param);
        break;
      case 'loadSelected':
        this.onloadSelectedMeddraNode(buttonAction.param);
        break;
      case 'moveToModifyNode':
        this.onMoveToModifyNode(buttonAction.param);
        break;
    }
  }

  onMoveToModifyNode(currentNode: any) {
    let goToNode  = Art57NodeUtils.findFirstChildNodeOfType(currentNode.parent.parent, QueryFieldsNode);
    const conditionsNode = Art57NodeUtils.findFirstChildNodeOfType(currentNode.parent.parent, QueryConditionsNode);    
    if (currentNode.conditionsNode!.data.fields.some((field: any) => field.props.isModified)) {
      const newNode = (currentNode.conditionsNode as QueryConditionsNode).cloneNode(goToNode!.parent as BaseNode);
      currentNode.parent.parent.children[1] = newNode;
      goToNode  = Art57NodeUtils.findFirstChildNodeOfType(newNode.parent, QueryConditionsNode);
    } else {
      const newNode = (currentNode.fieldsNode as QueryFieldsNode).cloneNode(goToNode!.parent as BaseNode);
      currentNode.parent.parent.children[0] = newNode;
      goToNode  = Art57NodeUtils.findFirstChildNodeOfType(newNode.parent, QueryFieldsNode);
    }
    this.onNodeSelect({ node: goToNode });

  }

  onLoadMeddraNode(node: MeddraNode) {
    const meddraLevelNode: TreeNodeMeddraLevel = node.getEntityNode() as TreeNodeMeddraLevel;
    const newChild = meddraLevelNode!.addChild(node.data.model);
    this.onNodeSelect({ node: newChild });
    this.cdr.detectChanges();
    this.setTreeViewScroll(newChild!.key!);
  }


  onloadSelectedMeddraNode(node: BaseNode) {
    let model: any[] = node.data.model;
    model = model.filter(model => model.checked);
    if (model.length > 0) {
      this.injector.get(ConfirmationService).confirm({
        header: 'Message from webpage',
        message: `<span> Are you sure you want to load the selected item(s)?</span>`,
        icon: 'pi pi-question-circle',
        acceptLabel: 'Ok',
        rejectLabel: 'Cancel',
        accept: () => {

          let meddraLevelNode: TreeNodeMeddraLevel;
          if (node instanceof TreeNodeMeddraLevel) {
            meddraLevelNode = node;
          } else {
            const queryNode: MeddraQueryNode = Art57NodeUtils.findFirstParentNodeOfType(node, MeddraQueryNode) as MeddraQueryNode;
            if (queryNode) {
              meddraLevelNode = queryNode.entityNode as TreeNodeMeddraLevel;
            }
          }

          meddraLevelNode!.addChildren(model);
        },
        reject: () => {
          // do nothing
        }
      });
    } else {
      this.injector!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'Item not selected', life: environment.errorElapsedTime });
    }
  }

  exportToExcel(selectedNode: MeddraQueryResultNode) {
    selectedNode.exportToExcel();
  }


  runToExcel(selectedNode: BaseNode) {
    if (!this.existsErrors(selectedNode)) {
      const queryNode: any = Art57NodeUtils.findFirstCurrentOrParentNodeOfType(selectedNode, QueryNode);
      queryNode.executeQueryToExcel();
    }
  }

  onNextPage(selectedNode: QueryNode) {
    selectedNode.nextPage(selectedNode);
  }

  onPreviousPage(selectedNode: QueryNode) {
    selectedNode.previousPage(selectedNode);
  }

  onTopPage(selectedNode: QueryNode) {
    selectedNode.topPage(selectedNode);
  }

  isTreeContainerVisible: boolean = true;

  toggleTreeContainer(): void {
    this.isTreeContainerVisible = !this.isTreeContainerVisible;
  }

  existsErrors(selectedNode: BaseNode): boolean {
    const meddraQueryNode = Art57NodeUtils.findFirstCurrentOrParentNodeOfType(selectedNode, MeddraQueryNode);
    const meddraQueryConditions = Art57NodeUtils.findFirstChildNodeOfType(meddraQueryNode!, QueryConditionsNode);
    const errorsFound = ErrorControlUtil.findErrors(this.injector, [meddraQueryConditions!], this.formlyBuilder, this.selectedNode, false);
    const errorControl: FieldsErrorsControl = new FieldsErrorsControl();
    errorControl.initializeErrors(errorsFound);
    if (errorControl.existsErrors()) {
      this.confirmValidateErrors(errorControl);
      return true;
    }
    return false;
  }

  private confirmValidateErrors(errorControl: FieldsErrorsControl) {
    const firstError: any = errorControl.getFirstError();
    const errorNodeLabel: string = firstError.node.labelNodeName;
    this.confirmationService.confirm({
      header: 'Message from webpage',
      message: `Cannot Run Query: ${errorControl.getTotalErrorsFound()}  Error(s) present.` +
        `<br><br><strong>First error(s):</strong><br>` +
        errorNodeLabel + (firstError.controlLabel ? '/' + firstError.controlLabel : '') + '<br><br>' + firstError.error + '<br><br>',
      icon: 'pi pi-question-circle',
      acceptLabel: 'Ok',
      rejectLabel: 'Cancel',
      accept: () => {
        this.gotoErrorNode(firstError.node, firstError.controlId);
      },
      reject: () => {
        // do nothing
      }
    });
  }


  gotoErrorNode(node: TreeNode<any>, controlId: string) {
    this.expandParentNodes(node);
    this.onNodeSelect({ node: node });
    this.cdr.detectChanges(); // allow detection that component view is draw in browser so we can change the focus in the right view
    this.setFormlyFormField(controlId);
  }

  setFormlyFormField(formlyFieldFocus: string) {

    if (formlyFieldFocus != '') {

      const formlyForm = (this.detail_view_component as any).formly_detailed_view_component;
      if (formlyForm) {
        formlyForm.setFocusOnFormlyField(formlyFieldFocus);
      }
    }
  }

}
